import { toFloat } from '@/models/Utils'
import { EditCreateFields } from '../observation'
import { WellObservation, wellObservationApolloModel, WellObservationParams } from './WellObservation'

export const bdwApolloModel = wellObservationApolloModel(
  ` casingPressure
    tubingPressure
    waterVolume`
)

export const bdwFields : EditCreateFields[] = [
  {
    title: 'Casing Pressure',
    name: 'casingPressure',
    type: 'decimal',
    limits: [6, 2]
  },
  {
    title: 'Tubing Pressure',
    name: 'tubingPressure',
    type: 'decimal',
    limits: [6, 2]
  },
  {
    title: 'Water Volume',
    name: 'waterVolume',
    type: 'decimal',
    limits: [10, 4],
    unit: 'Water',
    required: false
  }
]

export interface BDWParams extends WellObservationParams {
  casingPressure?: number | null
  tubingPressure?: number | null
  waterVolume?: number | null
}

export class BDW extends WellObservation {
  private _casingPressure: number | null = null
  private _tubingPressure: number | null = null
  private _waterVolume: number | null = null

  constructor (fieldObservation?: BDWParams) {
    super(fieldObservation)

    if (fieldObservation !== undefined) {
      if (fieldObservation.casingPressure !== undefined) {
        this._casingPressure = fieldObservation.casingPressure
      }
      if (fieldObservation.tubingPressure !== undefined) {
        this._tubingPressure = fieldObservation.tubingPressure
      }
      if (fieldObservation.waterVolume !== undefined) {
        this._waterVolume = fieldObservation.waterVolume
      }
    }
  }

  get casingPressure (): number | null {
    return this._casingPressure
  }

  set casingPressure (value: number | null) {
    value = this.convertUndefinedToNull(value)
    this._casingPressure = value
  }

  get tubingPressure (): number | null {
    return this._tubingPressure
  }

  set tubingPressure (value: number | null) {
    value = this.convertUndefinedToNull(value)
    this._tubingPressure = value
  }

  get waterVolume (): number | null {
    return this._waterVolume
  }

  set waterVolume (value: number | null) {
    value = this.convertUndefinedToNull(value)
    this._waterVolume = value
  }

  getApolloModel () {
    return {
      casingPressure: toFloat(this.casingPressure),
      tubingPressure: toFloat(this.tubingPressure),
      waterVolume: toFloat(this.waterVolume)
    }
  }

  getApolloFormattedModel () {
    return {
      ...super.getApolloFormattedModel(),
      ...this.getApolloModel()
    }
  }

  getApolloFormattedModelForEdit () {
    return {
      ...super.getApolloFormattedModelForEdit(),
      ...this.getApolloModel()
    }
  }
}
